import { DATE_FORMAT, getDate } from '@belong/date-utils';
import { IInternetPlan } from '@belong/types';

export const isLegacyPlan = ({
  expiryDate,
  futurePrice
}: Pick<IInternetPlan, 'expiryDate' | 'futurePrice'>): boolean => {
  return !!(expiryDate && futurePrice);
};

/**
 * This will return the expiry date + 1 day. This is so the date displayed to customers as the content
 * will be something like this:
 *
 * `From 01 July 2025 the price will be $87`
 */
export const getLegacyExpiryDate = (expiryDate?: string): string | undefined => {
  if (!expiryDate) {
    return;
  }

  // Strip of the time portion, if it is there
  const rawDate = getDate(expiryDate.split('T').shift(), DATE_FORMAT.ISO);

  // Add one day to the date
  const returnDate = rawDate.add(1, 'day');

  // Return the formatted date
  return returnDate.format(DATE_FORMAT.DAY_MONTH_YEAR);
};
